import React from "react";
import {
  baseStyles,
  sizeStyles,
  disabledStyles,
  typeStyles,
} from ".././utils/css/baseStyles";
import { ButtonProps } from "./ComponentProps";
import { useTranslation } from "react-i18next";

const Button: React.FC<ButtonProps> = ({
  type,
  size,
  text,
  onClick,
  isDisabled = false,
  styles,
}) => {
  const buttonClasses = `${baseStyles} ${sizeStyles[size]} ${
    isDisabled ? `${typeStyles[type]} ${disabledStyles}` : typeStyles[type]
  }`;
  const { t, i18n } = useTranslation();

  return (
    <button
      className={`${buttonClasses} w-full`}
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
      style={styles || undefined}
    >
      {t(text)}
    </button>
  );
};

export default Button;
